/**
* 维度一览
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>维度一览</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
      <el-form-item label="题库">
        <el-select size="small" v-model="searchForm.questionBankId" placeholder="请选择题库">
          <el-option
            v-for="item in questionBankList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称">
        <el-input size="small" v-model="searchForm.name" placeholder="输入名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="name" label="名称">
      </el-table-column>
      <el-table-column prop="questionBankId" label="绑定题库" width="200" :formatter="parentFormatter">
      </el-table-column>
      <!-- <el-table-column prop="status" label="状态" width="200">
        <template v-slot:default="scope">
          <div v-if="scope.row.status===1">
            <el-tag type="success">完成</el-tag>
          </div>
          <div v-if="scope.row.status!==1">
            <el-tag type="danger">有题目未绑定</el-tag>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="createTime" label="修改时间" width="150">
        <template v-slot:default="scope">
          <div>{{ scope.row.createTime|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="200">
        <template v-slot:default="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="题库" prop="questionBankId">
          <el-select size="small" v-model="editForm.questionBankId" placeholder="请选择题库">
            <el-option
              v-for="item in questionBankList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {questionBankList, statisticMethodDelete, statisticMethodList, statisticMethodSave} from '../../api/api'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        id: '',
        name: '',
        questionBankId: ''
      },
      // 题库下拉
      questionBankList: [],
      // rules表单验证
      rules: {
        questionBankId: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ]
      },
      searchForm: {
        page: 1,
        limit: 10,
        questionBankId: ''
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      listData: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.questionBankDropDown();
    this.getData(this.searchForm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    questionBankDropDown() {
      questionBankList({deleteFlg: 0})
        .then(res => {
          this.questionBankList = res.data;
          if (this.questionBankList && this.questionBankList.length > 0) {
            this.searchForm.questionBankId = this.questionBankList[0].id
          }
          this.getData(this.searchForm);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('下拉列表查询失败！')
        })
    },
    // 获取维度列表
    getData(parameter) {
      this.loading = true
      statisticMethodList(parameter)
        .then(res => {
          this.loading = false
          this.listData = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('查询失败！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.searchForm.page = parm.currentPage
      this.searchForm.limit = parm.pageSize
      this.getData(this.searchForm)
    },
    // 搜索事件
    search() {
      this.getData(this.searchForm)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row !== undefined && row !== 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.questionBankId = row.questionBankId
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          statisticMethodSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code === 200) {
                this.getData(this.searchForm)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除维度
    handleDelete(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        statisticMethodDelete(row.id)
          .then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '维度已删除!'
              })
              this.getData(this.searchForm)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
          this.loading = false
          this.$message.error('维度删除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 题库格式化
    parentFormatter(row, column, cellValue, index) {
      const item = this.questionBankList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/scoreRule/WeiDu.vue